<!--
  File name: ReportCard.vue
  Program Description:
    - This component is used as the card template by the Reports Generation.
    - This component returns the selected toggle button value.
-->
<template>
  <v-card
    class="mb-4"
    :min-height="minHeight"
  >
    <v-card-title
      style="border-bottom: thin solid rgba(0, 0, 0, 0.12)"
    >
      {{ title }}
      <v-spacer />
      <template v-if="canToggleSector">
        <v-btn-toggle
          v-model="sectorToggleButton"
          mandatory
          multiple
          dense
        >
          <v-btn>
            Sector
          </v-btn>
          <v-btn v-show="showSubsector">
            Subsector
          </v-btn>
        </v-btn-toggle>
      </template>
      <template v-if="toggle">
        <v-btn-toggle
          v-model="toggleButton"
          mandatory
          dense
          class="ml-4"
        >
          <v-btn>
            <v-icon>bar_chart</v-icon>
          </v-btn>
          <v-btn>
            <v-icon>pie_chart</v-icon>
          </v-btn>
        </v-btn-toggle>
      </template>
    </v-card-title>
    <v-card-text>
      <v-row>
        <v-col>
          <slot :sectorToggleButton="sectorToggleButton" />
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  name: 'ReportCard',
  props: {
    value: {
      type: Object,
      default: () => ({})
    },
    title: {
      type: String,
      default: ''
    },
    minHeight: {
      type: String,
      default: ''
    },
    toggle: {
      type: Boolean,
      default: false
    },
    canToggleSector: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    loading: {
      type: Boolean,
      default: false
    },
    showSubsector: {
      type: Boolean,
      default: false
    }
  },
  data: () => ({
    sectorToggleButton: [0, 1],
    toggleButton: 0
  }),
  mounted () {
    this.$watch('sectorToggleButton', this.updateModelValue)
    this.$watch('toggleButton', this.updateModelValue)
  },
  methods: {
    updateModelValue () {
      this.$emit('input', { ...this.$data })
    }
  }
}
</script>
